import styled from 'styled-components'

import {
    DropdownMenu as DropdownMenuBase,
    MenuItem as MenuItemBase,
} from '@icontainers/design-system/dist/organisms/DropdownMenu'

export const DropdownMenu = styled(DropdownMenuBase)`
    display: flex;
    align-items: center;

    & .right {
        margin-top: unset;
    }

    & .right > .right {
        right: 0px;
        margin-right: 0px;
        border: 0px;
        border-radius: 0px;
    }

    & .right:after,
    & .right:before {
        content: unset;
    }
`

export const MenuItem = styled(MenuItemBase)`
    padding: 10px 15px;
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.regular}
    border: 0px;

    :hover {
        background: ${(props) => props.theme.color.p500};
        color: ${(props) => props.theme.color.white};
    }
`

export const Title = styled.div`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.bold};
    color: ${(props) => props.theme.color.a500};
    padding: 15px 10px;
    text-transform: uppercase;
    min-width: 180px;
`
